import {
    createWebHistory,
    createRouter
} from "vue-router";

const routes = [
    {
        path: "/",
        alias: "/home",
        name: "home",
        component: () =>
            import ("./components/SearogSecondHome")
    }, 
    {
        path: "/",
        alias: "/packages",
        name: "packages",
        component: () =>
            import ("./components/SearogHome")
    }, 
    {
        path: "/login",
        alias: "/login",
        name: "login",
        component: () =>
            import ("./components/SearogLogin")
    }, 
    {
        path: "/register",
        alias: "/register",
        name: "register",
        component: () =>
            import ("./components/SearogRegister")
    }, 
    {
        path: "/cart",
        alias: "/cart",
        name: "checkout",
        component: () =>
            import ("./components/SearogCheckout")
    }, 
    {
        path: "/registration",
        alias: "/registration",
        name: "registration",
        component: () =>
            import ("./components/SearogRegistration")
    }, 
    {
        path: "/success",
        alias: "/success",
        name: "success",
        component: () =>
            import ("./components/SearogSuccessPage")
    }, 
    {
        path: "/failed",
        alias: "/failed",
        name: "failed",
        component: () =>
            import ("./components/SearogFailedPage")
    }, 
    {
        path: "/pending",
        alias: "/pending",
        name: "pending",
        component: () =>
            import ("./components/SearogPendingPage")
    }, 
    {
        path: "/about",
        alias: "/about",
        name: "about",
        component: () =>
            import ("./components/SearogAbout")
    }, 
    {
        path: "/tnc",
        alias: "/tnc",
        name: "tnc",
        component: () =>
            import ("./components/SearogTnC")
    }, 
    {
        path: "/info",
        alias: "/info",
        name: "info",
        component: () =>
            import ("./components/SearogInfo")
    }, 
    {
        path: "/programme",
        alias: "/programme",
        name: "programme",
        component: () =>
            import ("./components/SearogProgramme")
    }, 
    {
        path: "/admindashboard",
        alias: "/admindashboard",
        name: "admindashboard",
        component: () =>
            import ("./components/SearogDashboard")
    }, 
];

const router = createRouter({
    scrollBehavior() {
        // always scroll to top
        return { top: 0 }
      },
    history: createWebHistory(),
    routes,
});

export default router;